import { Divider, Icon, List, Message } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { Button } from '@britishcouncil/react-admin';

export const ImportResultMessage = ({
  successfulImports,
  failedImports,
  onDownloadErrorFile,
}: {
  successfulImports?: number;
  failedImports?: number;
  onDownloadErrorFile: () => void;
}) => {
  const hasFailures = !!failedImports && failedImports > 0;

  return (
    <Message positive={!hasFailures} warning={hasFailures} data-testid="bulk-import-result">
      <Message.Header>
        {hasFailures
          ? 'File was uploaded successfully, but some imports failed'
          : 'File was uploaded successfully'}
      </Message.Header>
      <p>
        Successful imports: <b>{successfulImports}</b> / Failed imports: <b>{failedImports ?? 0}</b>
      </p>
      {hasFailures && (
        <S.Button basic icon onClick={onDownloadErrorFile} size="tiny" color="orange">
          Download incorrect entries file&nbsp;
          <Icon name="download" />
        </S.Button>
      )}
    </Message>
  );
};

export const ErrorResultMessage = ({
  errorMessages,
  isTimedOut,
  isServerError,
}: {
  errorMessages?: string[];
  isTimedOut?: boolean;
  isServerError?: boolean;
}) => (
  <Message negative data-testid="bulk-import-error">
    <Message.Header>Error occurred when uploading file</Message.Header>
    {isTimedOut && <p>Import timed out. Please try again.</p>}
    {isServerError && <p>An error occurred while processing the import. Please try again.</p>}
    {errorMessages && errorMessages.length > 0 && (
      <>
        {errorMessages.length === 1 ? (
          <p>{errorMessages[0]}</p>
        ) : (
          <List bulleted items={errorMessages} />
        )}
        <Divider />
      </>
    )}
    <p>Make sure that you are uploading correct file or try again.</p>
  </Message>
);

export const InvalidTemplateMessage = () => (
  <Message negative data-testid="bulk-import-invalid-template">
    <Message.Header>Uploaded invalid template</Message.Header>
    <p>
      Please make sure you are uploading the correct and most recent template and try again. If you
      are not sure what template you are using, you can download the latest one above.
    </p>
  </Message>
);

const S = {
  Button: styled(Button)`
    box-shadow: none !important;
    padding: 0 !important;
    &:hover {
      text-decoration: underline;
    }
  `,
};
